const initialState = {
    "paso": 0,
    "email": "",
};

export function olvideContraseniaRdc(state = initialState, action) {

    switch (action.type) {
        case "SET_EMAIL":
            return {
                ...state,
                "email": action.email
            };
        case "PASO_SIGUIENTE_OLVIDE_CONTRASENIA":
            return {
                ...state,
                "paso": action.paso
                
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/gnp-olvide-contrasenia/reducer.js